import { Pipe, PipeTransform } from '@angular/core';
import { ProductGroup } from '@spa/api';
import { Helper } from '../classes';

@Pipe({
  name: 'productGroup'
})
export class ProductGroupPipe implements PipeTransform {
  transform(group: ProductGroup): string {
    return Helper.textsHelper().getProductGroupName(group);
  }
}
